import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { features } from "../Constants";

const Services = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <section className="relative bg-[#121212] py-20 px-6 sm:px-10 lg:px-20" id="servicios">
      {/* Título */}
      <div className="text-center max-w-4xl mx-auto mb-16" data-aos="fade-down">
        <h2 className="text-3xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight">
          Servicios diseñados para{" "}
          <span className="bg-gradient-to-r from-blue-600 to-blue-400 text-transparent bg-clip-text">
            hacer crecer tu negocio
          </span>
        </h2>
        <p className="text-neutral-400 mt-4 text-base sm:text-lg">
          Cada pieza que desarrollamos encaja perfectamente en tu estrategia digital.
        </p>
      </div>

      {/* Tarjetas */}
      <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 max-w-[1400px] mx-auto">
        {features.map((feature, index) => (
          <div
            key={index}
            data-aos="fade-up"
            data-aos-delay={index * 100}
            className="bg-[#1c1c1c] border border-blue-500/10 rounded-2xl p-6 text-center transition hover:scale-[1.03] hover:shadow-lg hover:shadow-blue-600/20"
          >
            <div className="w-12 h-12 mx-auto mb-4 bg-blue-600 rounded-full flex items-center justify-center text-white">
              {feature.icon}
            </div>
            <h3 className="text-white text-xl font-semibold mb-2">{feature.text}</h3>
            <p className="text-neutral-400 text-sm leading-relaxed">
              {feature.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
